import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const COLORS = ['#FF6B00', '#437011', '#2563EB', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#6366F1'];

const DiplomeChart = ({ data }) => {
  if (!data || data.length === 0) return null;

  // Take top 6 for better display
  const chartData = data.slice(0, 6);

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
      <div className="h-2 bg-gradient-to-r from-orange-500 to-orange-300"></div>
      <div className="p-5">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Distribution des diplômes</h3>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 5, right: 20, bottom: 25, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis 
                dataKey="name" 
                stroke="#6b7280" 
                fontSize={11}
                angle={-30}
                textAnchor="end"
                height={50}
              />
              <YAxis stroke="#6b7280" fontSize={12} />
              <Tooltip 
                contentStyle={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}
                labelStyle={{ color: '#374151' }}
              />
              <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DiplomeChart;
